import { render, staticRenderFns } from "./Sidebars.vue?vue&type=template&id=b9426d2a"
import script from "./Sidebars.vue?vue&type=script&lang=js"
export * from "./Sidebars.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports